import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  recentSearches: [],
};

const mapRecentSearches = (recentSearches, payload) => {
  return [payload, ...recentSearches.filter((v) => v !== payload)].slice(0, 5);
};

const globalSearch = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GLOBAL_SEARCH_ADD_TO_RECENT:
      return {
        ...state,
        recentSearches: mapRecentSearches(state.recentSearches, payload),
      };
    case actionTypes.GLOBAL_SEARCH_CLEAR_RECENT:
      return {
        recentSearches: [],
      };
    default:
      return state;
  }
};

export default globalSearch;
